export const formatPriceWithComma = (price: number, unit = '원') =>
  `${price.toLocaleString()}${unit}`;
